'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ComposerContainer } from '#pplx/frontend/composer-sdk/ComposerContainer.js';
import { ComposerProvider } from '#pplx/frontend/composer-sdk/ComposerProvider.js';
import { useComposer } from '#pplx/frontend/composer-sdk/useComposer.js';
import React from 'react';
export const Wrapper = React.memo(function Wrapper({ initialLayout = 'expanded', children, ...props }) {
    return (_jsx(ComposerProvider, { initialState: {
            draftMode: 'uncontrolled',
            isExpanded: initialLayout === 'expanded',
            isActive: false,
            isComposing: false,
            status: 'idle',
            hasDraft: false,
            isDisabled: false,
        }, children: _jsx(WrapperContent, { ...props, initialLayout: initialLayout, children: children }) }));
});
const WrapperContent = React.memo(function WrapperContent({ initialLayout = 'expanded', children, ...props }) {
    const { isActive, isExpanded } = useComposer();
    return (_jsx(ComposerContainer, { ...props, initialLayout: initialLayout, isActive: isActive, isExpanded: isExpanded, children: children }));
});
//# sourceMappingURL=Wrapper.js.map